import React from "react";

const PrivacyPolicy = () => (
  <div className="max-w-2xl mx-auto py-12 px-4">
    <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
    <p className="mb-4">
      <strong>Effective Date:</strong> 15 September 2025
    </p>
    <p className="mb-4">
      This Privacy Policy explains how we collect, use, and protect your personal information when you use our application. By using our services, you agree to the collection and use of information in accordance with this policy.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">Information We Collect</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>Personal identification information (Name, email address, phone number, etc.)</li>
      <li>Uploaded documents and profile photos</li>
      <li>Usage data and device information</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">How We Use Your Information</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>To provide and maintain our services</li>
      <li>To communicate with you</li>
      <li>To improve our application</li>
      <li>To comply with legal obligations</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">Information Sharing</h2>
    <p className="mb-4">
      We do not sell or share your personal information with third parties except as required by law or to provide our services.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">Data Security</h2>
    <p className="mb-4">
      We take reasonable measures to protect your information from unauthorized access, alteration, or disclosure.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">Your Rights</h2>
    <p className="mb-4">
      You have the right to access, update, or delete your personal information. Please contact us if you wish to exercise these rights.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">Contact Us</h2>
    <p>
      If you have any questions about this Privacy Policy, please contact us on <a href="tel:+256756527240" className="text-blue-600 underline">+256756527240</a>.
    </p>
  </div>
);

export default PrivacyPolicy;
